// Positions sort/filter defaults and entitlement handling (KAN-138).
// Sort/filter is a paid-plan feature (`position_sort_filter`). The dashboard keeps the raw
// control state, and everything that reads it goes through getEffectiveSortFilter so state left
// over from a paid plan (downgrade, trial expiry, switching to a free school) is ignored.

export const DEFAULT_POS_SORT_FIELD = 'posted';
export const DEFAULT_POS_SORT_DIR = 'desc';

export const DEFAULT_SORT_FILTER = {
  sortField: DEFAULT_POS_SORT_FIELD,
  sortDir: DEFAULT_POS_SORT_DIR,
  statusFilter: [],
  offeredTo: 'all',
  filledBy: 'all',
  afterDate: '',
  beforeDate: '',
};

// Returns the sort/filter values the list should actually use: the raw state when the school's
// plan includes the feature, the defaults otherwise.
export function getEffectiveSortFilter(canSortFilter, values) {
  return canSortFilter ? values : DEFAULT_SORT_FILTER;
}

// Number of drawer settings that differ from their defaults (each filter control counts once,
// a non-default sort counts once). The search box lives outside the drawer and is not counted.
export function countActiveSortFilter({ sortField, sortDir, statusFilter, offeredTo, filledBy, afterDate, beforeDate }) {
  return [
    sortField !== DEFAULT_POS_SORT_FIELD || sortDir !== DEFAULT_POS_SORT_DIR,
    statusFilter.length > 0,
    offeredTo !== 'all',
    filledBy !== 'all',
    !!afterDate,
    !!beforeDate,
  ].filter(Boolean).length;
}
